import { jsx as h } from "react/jsx-runtime";
import { SvgIcon as o } from "../SvgIcon.js";
const m = (v) => /* @__PURE__ */ h(o, { ...v, children: /* @__PURE__ */ h("path", { d: "M17.1176 14.4235V9.98822h-.0117v-.87057h-6.2118V5.55294h.8706V2H8.21176v3.55294h.90589v3.56471H2.90588V14.4235H2v3.553h3.55294v-3.553h-.87059v-3.5294h4.44706v3.5294h-.91765v3.553h3.55294v-3.553h-.8588v-3.5294h4.4353v3.5294h-.8941v3.553H18v-3.553h-.8824Z" }) });
export {
  m as Folder
};
//# sourceMappingURL=Folder.js.map
